module.exports = __webpack_public_path__ + "static/Glober_xBold-5991963fc6044adc0d2ade79560404b3.svg";